import { callAPI } from '../network';

export async function getEmployeePositions (companyId){
  
   const data = await callAPI(
                        null, 
                        'EmployeePosition/GetByCompanyId?companyId=' + companyId, 'get');
   return data || [ ];
}

